import React, { useState, useEffect, useRef } from "react";

const HomeSection1new = () => {
  const logo = `${process.env.PUBLIC_URL}/assets/Logo.webp`;

  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleLoadedData = () => {
      setLoaded(true);
    };

    const videoElement = videoRef.current;

    if (videoElement) {
      videoElement.addEventListener("loadeddata", handleLoadedData);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadeddata", handleLoadedData);
      }
    };
  }, []);

  return (
    <div className="w-full relative overflow-hidden">
      {!loaded && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/50">
          <img
            src={logo}
            alt="MBA Solutions"
            className="animate-ping w-[140px] h-[90px] object-contain"
          />
        </div>
      )}

      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className={`w-full h-[80vh] object-fill ${
          loaded ? "opacity-100" : "opacity-0"
        } transition-opacity duration-500`}
      >
        <source src="/video2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default HomeSection1new;
